module.exports = __webpack_public_path__ + "assets/media/leo-strupczewski-dark.1783c8dc.svg";